import { render, staticRenderFns } from "./dclshgz22026.vue?vue&type=template&id=f00482e8&scoped=true"
import script from "./dclshgz22026.vue?vue&type=script&lang=js"
export * from "./dclshgz22026.vue?vue&type=script&lang=js"
import style0 from "./dclshgz22026.vue?vue&type=style&index=0&id=f00482e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00482e8",
  null
  
)

export default component.exports